import styled from '@emotion/styled';
import ShareIcon from './Icons/ShareIcon';
import React, { useState } from 'react';
import ShareProject from './ShareProject';
import { Modal } from '../../../../../utils';

export default function ShareButton({ project, buttonComponent, viewMode, height = 44 }) {
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => {

    if(viewMode){
      return;
    }

    setShowModal(true);

  }

  return (
    <>
      <ShareWrapper>
        {buttonComponent ? (
          <div onClick={() => handleShowModal(true)}>{buttonComponent}</div>
        ) : (
          <ShareButtonItem height={height} onClick={() => handleShowModal(true)}>
            <ShareIcon />
            {/*<LikeText>{project?.shares_count ?? 0}</LikeText>*/}
          </ShareButtonItem>
        )}

        <ShareToolTip className="share-tooltip">
          {project?.is_ticketable ? 'Event' : 'Projekt'} teilen
        </ShareToolTip>
      </ShareWrapper>

      <Modal showModal={showModal} handelCloseModal={() => setShowModal(false)}>
        <ShareProject
          subtitle={project.subtitle}
          title={project.title}
          banner={project.banner}
        />
      </Modal>
    </>
  );
}

const ShareWrapper = styled.div`
  position: relative;
  display: inline-flex;

  &:hover .share-tooltip {
    opacity: 1;
    visibility: visible;
    transform: translateX(-50%) translateY(0);
  }
`;

const ShareToolTip = styled.div`
  position: absolute;
  left: 50%;
  top: -48px;

  transform: translateX(-50%) translateY(6px);
  padding: 8px 12px;

  min-width: 104px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;

  background: #0a0d12;
  border-radius: 8px;

  box-shadow: 0px 12px 16px -4px rgba(10, 13, 18, 0.08),
    0px 4px 6px -2px rgba(10, 13, 18, 0.03),
    0px 2px 2px -1px rgba(10, 13, 18, 0.04);

  /* Text xs/Semibold */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  /* identical to box height, or 150% */
  text-align: center;

  color: #ffffff;

  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  z-index: 999;

  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s ease;

  &::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 50%;

    transform: translateX(-50%) rotate(45deg);

    width: 12px;
    height: 12px;

    background: #0a0d12;
  }
`;

const ShareButtonItem = styled.div`
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  padding: 10px 18px;
  gap: 6px;

  width: auto;
  height: ${(props) => props.height+"px" || '44px'};

  background: ${(props) => (props.isLiked ? '#f5fbee' : '#fff')};
  border: 1px solid ${(props) => (props.isLiked ? '#acdc79' : '#d5d7da')};

  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);

  border-radius: 8px;

  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background: #f5fbee;
    border-color: #acdc79;
    cursor: pointer;
  }
`;

const LikeText = styled.span`
  font-family: 'Inter';
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;

  color: #3f621a;
  white-space: nowrap;
`;
